import React from 'react';
import { useContent } from '../content/ContentProvider';
import '../styles/glass.css';

interface FooterProps {
  property?: 'mobile' | 'desktop';
}

export const Footer: React.FC<FooterProps> = () => {
  const { footer } = useContent();
  const year = String(new Date().getFullYear());

  return (
    <footer className="site-footer">
      <span>{footer.left.replace('{year}', year)}</span>
      <span>{footer.right}</span>
    </footer>
  );
};
